module.exports = __webpack_public_path__ + "static/media/brand.9d825dbe.svg";